import React, { useState } from "react";
import "./style.css";
import { assessmentIcons } from "../../../../../utils/assessmentIcons";
import { useSelector } from "react-redux";

const PhysicalRadioGraph = ({ radioGraphContainerRef, onFullScreen }) => {
  const currentCaseDetail = useSelector(
    (state) => state.ageAssessmentCase?.currentCaseDetail || null
  );

  let additional_images = currentCaseDetail?.additional_images || [];
  if (currentCaseDetail?.opg && currentCaseDetail.opg.trim() !== "") {
    additional_images = [currentCaseDetail.opg, ...additional_images]; // Insert at index 0
  }
  const [zoomLevel, setZoomLevel] = useState(100);
  const [rotationAngle, setRotationAngle] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  // Add handlers for zoom and rotate
  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 20, 200));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 20, 40));
  };
  const handleRotate = () => {
    setRotationAngle((prev) => (prev + 90) % 360);
  };
  return (
    <div className="physical_radio_graph_container">
      <div className="physical_radio_graph_body">
        <div className="_header">
          <p>Case Radiograph</p>
        </div>
        <div className="_main">
          <div className="_gallery">
            <img
              src={additional_images[currentIndex]}
              className="full_image"
              ref={radioGraphContainerRef}
              style={{
                transform: `scale(${
                  zoomLevel / 100
                }) rotate(${rotationAngle}deg)`,
                transition: "transform 0.3s ease",
              }}
            />
          </div>
        </div>
        <div className="_footer">
          <div className="_footer_options">
            <img src={assessmentIcons.zoomIn} onClick={handleZoomIn} />
            <img src={assessmentIcons.zoomOut} onClick={handleZoomOut} />
          </div>
          <p>{currentIndex == 0 ? "Main OPG/PA" : "Additional Radiograph"}</p>
          <div className="_footer_options">
            <img src={assessmentIcons.rotate} onClick={handleRotate} />
            <img src={assessmentIcons.fullView} onClick={onFullScreen} />
          </div>
        </div>

        <div className="radio_graphs_selection">
          <strong>Select Radiograph</strong>
          <div className="radio_graphs">
            {additional_images?.map((item, index) => (
              <img
                key={index}
                src={item}
                alt={`Image ${index + 1}`}
                onClick={() => setCurrentIndex(index)}
                style={{
                  border: currentIndex === index ? "3px solid #20c3ff" : "",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhysicalRadioGraph;
